import { render, staticRenderFns } from "./link-item.vue?vue&type=template&id=6f73e6c2&scoped=true&"
import script from "./link-item.vue?vue&type=script&lang=js&"
export * from "./link-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f73e6c2",
  null
  
)

export default component.exports